import PanAnimation from "../../../logic/PanAnimation";
import PartyTarget from "../../../model/character/PartyTarget";
import MineControl from "../../../model/control/MineControl";
import Damage from "../../../model/crew/Damage";
import Statistics from "../../../model/statistics/Statistics";
import Values from "../../../model/value/Values";
import Projection from "../../../Projection";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import BottomRowButtonContainer from "./BottomRowButtonContainer";
import RowContainerDamage from "./RowContainerDamage";
import RowContainerMineControl from "./RowContainerMineControl";

export default class BottomRowContainer extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {Damage} damage
     * @param {Values} values
     * @param {PartyTarget} partyTarget
     * @param {MineControl} mineControl
     * @param {Crew} crew
     * @param {Projection} projection
     * @param {PanAnimation} panAnimation
     * @param {Statistics} statistics
     */
    constructor(parentId, elementId, damage, values, partyTarget, mineControl, crew, projection, panAnimation, statistics) {
        super(parentId, elementId);

        // this.addView(new MineControlView(elementId, mineControl))

        // this.addView(new MineDamageView(elementId, damage, values, partyTarget));

        this.addView(new RowContainerMineControl(elementId, 'bottomRowMineControl', mineControl, partyTarget));

        this.addView(new RowContainerDamage(elementId, 'bottomRowDamage', damage, values, partyTarget));

        this.addView(new BottomRowButtonContainer(elementId, 'bottomRowButtonContainer', projection, panAnimation));
    }

    /**
     * @override
     */
    initializeView() {
  
        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'bottom-row');

        super.initializeView();        
    }
}